export type RequestStatusType =
  | 'AdminRequestApproval'
  | 'SelfRequestStatus'
  | 'MemberRequestStatus'
  | 'MemberRequestApproval';

export const isRequestStatusTypeForApproval = (
  requestStatusType: RequestStatusType
) =>
  requestStatusType === 'MemberRequestApproval' ||
  requestStatusType === 'AdminRequestApproval';
